import { render } from "./MMenu.vue?vue&type=template&id=8f5763bc&scoped=true"
import script from "./MMenu.vue?vue&type=script&lang=js"
export * from "./MMenu.vue?vue&type=script&lang=js"

import "./MMenu.vue?vue&type=style&index=0&id=8f5763bc&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5763bc"]])

export default __exports__